import axiosInstance from "./axiosInstance";

export const editarTitular = async (data) => {
    return await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}/titular`,
        data,
        {
            withCredentials: true
        }
    );
}

export const deleteTitular = async (id) => {
    return await axiosInstance.delete(
        `${process.env.REACT_APP_BASE_URL}/delete-titular?id=${id}`,
        {
            withCredentials: true
        }
    );
}